import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e5874e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
import { Swiper, SwiperSlide } from "swiper/vue";
// import required modules
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { ref } from "vue";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
export default /*#__PURE__*/_defineComponent({
  __name: 'business-segment',
  setup(__props) {
    const modules = [FreeMode, Navigation, Thumbs];
    const thumbsSwiper = ref(null);
    const setThumbsSwiper = swiper => {
      thumbsSwiper.value = swiper;
    };
    const businessSegmentList = ["https://img2.qiuwenxinli.com/official-website/index/business-segment-1.jpg", "https://img2.qiuwenxinli.com/official-website/index/business-segment-2.jpg", "https://img2.qiuwenxinli.com/official-website/index/business-segment-3.jpg"];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_unref(Swiper), {
        onSwiper: setThumbsSwiper,
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        class: "thumb-swiper"
      }, {
        default: _withCtx(() => [_createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [_createTextVNode(" 幸福心理课 ")]),
          _: 1
        }), _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [_createTextVNode(" 全民幸福社APP ")]),
          _: 1
        }), _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [_createTextVNode(" 文创周边 ")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(Swiper), {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        thumbs: {
          swiper: thumbsSwiper.value
        },
        initialSlide: 1,
        modules: modules,
        pagination: {
          clickable: true
        },
        class: "business-segment"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(businessSegmentList, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            class: "business-segment-item",
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              class: "business-segment-item-img",
              src: item
            }, null, 8, _hoisted_1)]),
            _: 2
          }, 1024);
        }), 64))]),
        _: 1
      }, 8, ["thumbs"])]);
    };
  }
});